// extracted by css-extract-rspack-plugin
export default {"editHeaderWrapper":"SavedViewEditHeader-module__editHeaderWrapper__V7CXh"};